import type { ReactNode } from 'react';
import styles from './AuthLayout.module.scss';

export interface AuthLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className={styles.authLayout}>
      <div className={styles.authLayout__container}>
        {(title || subtitle) && (
          <div className={styles.authLayout__header}>
            {title && <h1 className={styles.authLayout__header__title}>{title}</h1>}
            {subtitle && <p className={styles.authLayout__header__subtitle}>{subtitle}</p>}
          </div>
        )}
        <div className={styles.authLayout__card}>{children}</div>
      </div>
    </div>
  );
}

export default AuthLayout;
